module.exports = __webpack_public_path__ + "static/media/down.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down.png
// module id = 885
// module chunks = 0